// extracted by mini-css-extract-plugin
module.exports = {"Title":"Project_Title__8sOWe"};